import DashboardItem, { proseClasses } from './dashboard-item';
import { PhConfetti, PhGear, PhSiren } from 'ember-phosphor-icons';
import { dashboardIconSizes } from 'tio-employee/utils/wellness-insights';

type ScoreIcon = typeof PhConfetti | typeof PhGear | typeof PhSiren;

/**
 * TODO: this is eventually supposed to have a link to observable document show page but
 * the custom wellness train payload doesn't include that yet; basic steps will be:
 *
 * - implement model relationships
 * - extend serializer (or maybe builder) to make association
 * - update translation and add link here with ActionableTranslation
 */

export default class WellnessInsightsDashScore extends DashboardItem {
  get scoreType() {
    return this.args.componentDefinition.name;
  }

  get icon(): ScoreIcon {
    switch (this.scoreType) {
      case 'score_on_track':
        return PhConfetti;
      case 'score_need_adjustment':
        return PhGear;
      case 'score_need_attention':
        return PhSiren;
      default:
        throw new Error(
          '@componentDefinition name prop invalid for WellnessInsightsDashScore component'
        );
    }
  }

  get iconSize() {
    return dashboardIconSizes.md;
  }

  get iconWeight() {
    // Heavier weight for PhSiren
    return this.scoreType === 'score_need_attention' ? 'fill' : 'regular';
  }

  get typeIntent() {
    switch (this.scoreType) {
      case 'score_on_track':
        return 'text-success';
      case 'score_need_adjustment':
        return 'text-warning';
      case 'score_need_attention':
        return 'text-danger';
      default:
        throw new Error(
          '@componentDefinition name prop invalid for WellnessInsightsDashScore component'
        );
    }
  }

  get iconClass() {
    return ['block', 'm-auto', this.typeIntent].join(' ');
  }

  get asOfDate() {
    const dateString = this.args.componentDefinition.wellnessTrain.obsUpdatedAt;
    return new Date(dateString).toLocaleDateString('en-US');
  }

  <template>
    <div class="w-full shrink-2 {{proseClasses}}">
      <div class="tio-flex-tight mb-1">
        <strong class="tio-row-center text-lg text-nowrap">
          {{this.translate "score.title" (hash name=this.scoreType)}}
          {{#let this.icon as |PhIcon|}}
            <PhIcon
              @size="22"
              @weight={{this.iconWeight}}
              class="align-middle ml-2 {{this.typeIntent}}"
            />
          {{/let}}
        </strong>
      </div>
      <div>{{this.translate "score.as_of_date" (hash date=this.asOfDate)}}</div>
    </div>
  </template>
}
